/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "accepted-outline",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "none",
                "stroke": "#AAAAAA",
                "strokeMiterlimit": "10"
            },
            "acceptedOutline": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "21",
            "height": "17"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 17", className: "accepted-outline", width: this.props.width, height: this.props.height, style: this.props.acceptedOutline },
            _react2["default"].createElement("path", { className: "st0", d: "M7.7 16.5c-.2 0-.5 0-.7-.1-.1 0-.2-.1-.2-.1-.2-.1-.3-.2-.4-.3l-.1-.1-5.2-5.1c-.4-.4-.6-.9-.6-1.4 0-.5.2-1 .6-1.4.4-.4.9-.6 1.4-.6.5 0 1 .2 1.4.6l3.7 3.7L17 1.2c.7-.8 2-.9 2.8-.2.4.4.6.8.7 1.4 0 .5-.2 1-.5 1.4L9.1 16c-.2.2-.4.3-.6.4-.3.1-.5.1-.8.1z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/accepted-outline.js